import apiClient from "./client";
export const StrToCurrency = (str: string | number) => {

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(+str);
};
export const timestampToDate = (timestamp: number) => {
  const date = new Date(timestamp);
  return date.toLocaleDateString("pt-BR", {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  });
};
export const timestampToDateTime = (timestamp: number) => {
  const date = new Date(timestamp);
  return date.toLocaleString("pt-BR", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  });
};

export const GameInfoService = {
  async getGameList(params: any) {
    const response: any = await apiClient.get("/api/game/hot/", { params });
    return response;
  },
  async getDraw(id: string) {
    const response: any = await apiClient.get(`/api/draw/${id}/`);
    return response;
  }
};

export const GAME_COLORS: Record<string, string> = {
  'Mega-Sena': '#1FD34C',
  'MEGA-SENA': '#1FD34C',
  'Quina': '#C848FF',
  'QUINA': '#C848FF',
  'Lotofácil': '#FFBD4B',
  'Lotofacil': '#FFBD4B',
  'LOTOFÁCIL': '#FFBD4B',
  'Lotomania': '#f59e0b',
  'LOTOMANIA': '#f59e0b',
  'Timemania': '#0ea5e9',
  'Dupla Sena': '#ef4444',
};
export const getGameColor = (name?: string): string =>
  name ? (GAME_COLORS[name] ?? '#3590ff') : '#3590ff';

// Base ticket size per game (K in C(N, K)). Keys mirror GAME_COLORS to
// tolerate the casing/accent variants the API returns inconsistently.
export const GAME_BASE_NUMBERS: Record<string, number> = {
  'Mega-Sena': 6,
  'MEGA-SENA': 6,
  'Quina': 5,
  'QUINA': 5,
  'Lotofácil': 15,
  'Lotofacil': 15,
  'LOTOFÁCIL': 15,
};
